/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { Picker } from 'vant';
import PopupSlide from '@/components/popup-slide';
import {
  Component, Model, Prop, Vue, Watch,
} from 'vue-property-decorator';

import { namespace } from 'vuex-class';

import UserPersonalInfoApi, { supplySave } from '@/api/userPersonalInfo';
import { UserVo } from '@/vo/user';
import { professinDictCode } from '@/constant';
import { SceneTypeEnum } from '@/enums/scene-type';
import style from './index.module.scss';
import { ApplyChooseList } from '../../types';

const PreApplyChooseStore = namespace('preApplyChoose');

@Component({
  name: 'ProfessionPicker',
})

export default class ProfessionPicker extends Vue {
  @PreApplyChooseStore.State applyChooseList!: ApplyChooseList | null;

  @Prop(Object) readonly needSupplyCommodityIds!: string[];

  $refs!: {
    professionPickerRef: Picker;
  };

  @Model('change', {
    type: Boolean,
  })
  private pop!: boolean

  private personInfo: Partial<UserVo.BasicInfo> = {};

  private professionList:OptionItem[] = [];

  private async created() {
    /** 获取职业字典项 */
    try {
      this.professionList = await DictApi.getProfessionType();
    } catch {
      this.professionList = [];
    }
  }

  /** 获取当前默认值下标 */
  private getDefaultIndex() {
    return this.professionList.findIndex(
      (item) => item.code === professinDictCode,
    );
  }

  // 关闭
  private close() {
    this.$emit('close');
  }

  // 确认职业字段并提现
  private async confirm() {
    this.$ubtPageButton(
      'finance_careerConfirmation',
      'commodityId',
      JSON.stringify(this.needSupplyCommodityIds),
    );
    const { id } = this.personInfo as unknown as Dictionary || {};
    // 调用补充职业字段接口
    const [pickerValue] = this.$refs.professionPickerRef.getIndexes();

    const formData:Dictionary = {
      profession: Number(this.professionList[pickerValue].code),
      id: id ? String(id) : '',
      commodityIds: this.needSupplyCommodityIds,
    };

    await supplySave(formData, SceneTypeEnum.PREAPPLY);

    this.$emit('confirm');
  }

  @Watch('pop')
  private async popVisale(val: boolean) {
    // 弹窗显示 曝光埋点
    if (val) {
      this.$ubtModuleExpose(
        'finance_careerConfirmationPopup',
        'commodityId',
        JSON.stringify(this.needSupplyCommodityIds),
      );
      // 获取补async 充资料数据
      try {
        this.personInfo = await UserPersonalInfoApi.getPersonalInfo();
        const { profession } = this.personInfo;
        if (!profession) {
          this.$nextTick(() => {
            this.$refs.professionPickerRef.setColumnIndex(0, this.getDefaultIndex());
          });
        } else {
          const index = this.professionList.findIndex(
            (item) => item.code === profession,
          );
          this.$nextTick(() => {
            this.$refs.professionPickerRef.setColumnIndex(0, index);
          });
        }
      } catch {
        this.$refs.professionPickerRef.setColumnIndex(0, this.getDefaultIndex());
      }
    }
  }

  private render() {
    return (
      <PopupSlide
        v-model={this.pop}
        popPostion="left"
        titlePostion="center"
        confirmText="确认"
        onConfirm={this.confirm.bind(this)}
        onClose={this.close.bind(this)}
        showClose={false}
        class={style.professionSelect}
      >
        <span class="title-tips" slot='title'>
            补充职业，提升
            <span style="color:#ec622b">领额成功率</span>
        </span>
        <Picker
          show-toolbar = {false}
          columns={this.professionList}
          value-key='name'
          slot='popupContent'
          ref="professionPickerRef"
        />
      </PopupSlide>
    );
  }
}
